import api from '@pray/shared/utils/api';

export type DuplicateExperimentParams = {
  experimentId: string;
  instanceName?: string;
  newName?: string;
};

export type DuplicateExperimentResponse = {
  data: {
    id: string;
    name: string;
    instance_name: string;
    control: {
      id: string;
      name: string;
      split: number;
    };
    variations: Array<{
      id: string;
      name: string;
      split: number;
    }>;
    created_at: string;
  };
};

/**
 * Duplicates an existing experiment
 * @param experimentId - The ID of the experiment to duplicate
 * @param instanceName - Optional instance name for faster lookup
 * @param newName - Optional new name for the duplicate (defaults to "{originalName} (Copy)")
 * @returns The newly created experiment
 */
export async function duplicateExperiment({
  experimentId,
  instanceName,
  newName,
}: DuplicateExperimentParams): Promise<DuplicateExperimentResponse> {
  if (!experimentId) throw new Error('Experiment ID is required');

  const url = `/web/studio/experiments/${experimentId}/duplicate`;
  const params = instanceName ? { instance_name: instanceName } : undefined;
  const body = newName ? { name: newName } : {};

  const response = await api.executePostRequest<DuplicateExperimentResponse>(url, body, { params });
  return response.data;
}
